import React from 'react';
import { Button } from './ui/button';
import { MessageCircle, FileText, Package } from 'lucide-react';
import { mockData } from '../mock';

const HeroSection = () => {
  const { company, contact } = mockData;

  const handleWhatsApp = () => {
    window.open(`https://wa.me/${contact.whatsapp.replace(/[^0-9]/g, '')}`, '_blank');
  };

  const scrollToContact = () => {
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="home" className="relative flex items-center pt-24 md:pt-28 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-4 md:space-y-6">
            <div className="flex flex-wrap items-center gap-2 md:gap-3">
              <span className="bg-green-600 text-white px-3 md:px-4 py-1.5 md:py-2 rounded-full text-xs md:text-sm font-semibold flex items-center">
                <Package className="h-3 w-3 md:h-4 md:w-4 mr-1.5 md:mr-2" />
                READY STOCK AVAILABLE
              </span>
              <span className="bg-blue-100 text-blue-900 px-3 md:px-4 py-1.5 md:py-2 rounded-full text-xs md:text-sm font-semibold">
                {company.established}
              </span>
            </div>
            
            <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 leading-tight">
              {company.tagline}
            </h1>

            <a href="/catalogue" className="block bg-green-600 text-white rounded-xl px-6 py-4 text-center hover:bg-green-700 transition-colors cursor-pointer">
              <p className="text-xl sm:text-2xl font-bold">View Catalogue</p>
            </a>
            
            <p className="text-lg md:text-xl text-blue-900 font-semibold">
              {company.subTagline}
            </p>
            
            <p className="text-base md:text-lg text-gray-600 leading-relaxed">
              {company.description}
            </p>
            
            <div className="flex flex-col sm:flex-row gap-3 md:gap-4 pt-2 md:pt-4">
              <Button
                onClick={scrollToContact}
                size="lg"
                className="bg-blue-900 hover:bg-blue-800 text-white px-6 md:px-8 py-5 md:py-6 text-base md:text-lg w-full sm:w-auto"
              >
                <FileText className="mr-2 h-4 w-4 md:h-5 md:w-5" />
                Get a Quote
              </Button>
              <Button
                onClick={handleWhatsApp}
                size="lg"
                variant="outline"
                className="border-2 border-blue-900 text-blue-900 hover:bg-blue-900 hover:text-white px-6 md:px-8 py-5 md:py-6 text-base md:text-lg w-full sm:w-auto"
              >
                <MessageCircle className="mr-2 h-4 w-4 md:h-5 md:w-5" />
                WhatsApp Us
              </Button>
            </div>

            {/* Trust Indicators */}
            <div className="grid grid-cols-3 gap-3 md:gap-6 pt-6 md:pt-8 border-t border-gray-200">
              <div>
                <div className="text-2xl md:text-3xl font-bold text-blue-900">8+</div>
                <div className="text-xs md:text-sm text-gray-600">Years Experience</div>
              </div>
              <div>
                <div className="text-2xl md:text-3xl font-bold text-blue-900">250+</div>
                <div className="text-xs md:text-sm text-gray-600">Happy Clients</div>
              </div>
              <div>
                <div className="text-2xl md:text-3xl font-bold text-green-600">48 hrs</div>
                <div className="text-xs md:text-sm text-gray-600">Fast Delivery</div>
              </div>
            </div>
          </div>

          {/* Right Content - Image */}
          <div className="relative order-first lg:order-last">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://customer-assets.emergentagent.com/job_alf-embroidery/artifacts/2ufpnijb_WhatsApp%20Image%202026-02-24%20at%205.22.59%20AM.jpeg"
                alt="Customized Work Uniform - Polo Shirt, Cargo Pants, Cap"
                className="w-full h-[300px] md:h-[500px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-blue-900/30 to-transparent"></div>
            </div>
            
            {/* Floating Badge */}
            <div className="absolute bottom-3 left-3 md:-bottom-6 md:-left-6 bg-white p-3 md:p-6 rounded-xl shadow-xl border-2 md:border-4 border-green-600">
              <div className="text-center">
                <div className="text-base md:text-2xl font-bold text-green-600">In Stock</div>
                <div className="text-xs text-gray-600">All Sizes Available</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
